export function formatCurrency(amount, locale = 'nl') {
  if (amount === null || amount === undefined) return '';
  const localeMap = { nl: 'nl-BE', fr: 'fr-BE', en: 'en-GB' };
  return new Intl.NumberFormat(localeMap[locale] || 'nl-BE', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount);
}
